import React, { useEffect, useRef, useState } from 'react';
import { MarketplaceOpportunity } from '../../../../../slices/marketplace/opportunity/models/opportunity';
import SellerProfileWrapper from '../../../../../components/MarketplaceSellerProfile/SellerProfileWrapper/SellerProfileWrapper';
import SellerMyProfileForm, {
    SellerMyProfileFormRef,
} from '../../../../../components/MarketplaceSellerProfile/SellerMyProfileForm/SellerMyProfileForm';
import { useStateSelector } from '../../../../../store/selectors';
import { MarketplaceSellerProfile } from '../../../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import './SellerProfileTab.scss';
import { useDispatch } from 'react-redux';
import { ViewSellerProfile } from '../../../../../slices/marketplace/opportunity/thunks/view-seller-profile.thunk';
import ButtonLoader from '../../../../../components/Layout/Buttons/ButtonLoader';
import createNotification from '../../../../../utils/createNotification';

interface SellerProfileTabProps {
    opportunity: MarketplaceOpportunity;
    isAdmin?: boolean;
}

const SellerProfileTab: React.FC<SellerProfileTabProps> = ({
    opportunity,
    isAdmin,
}) => {
    const isIdNdaSigned = opportunity.isIdNdaSigned;
    const dispatch = useDispatch() as any;
    const sellerProfile = useStateSelector(
        (state) => state.profilesData.selectedPofile
    ) as MarketplaceSellerProfile;
    const selectedOpportunity = useStateSelector(
        (state) => state.opportunities.selectedOpportuity
    );
    const formRef = useRef<SellerMyProfileFormRef>(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (
            isIdNdaSigned &&
            selectedOpportunity &&
            !selectedOpportunity.buyer?.hasViewedSellerProfile
        ) {
            dispatch(ViewSellerProfile(opportunity.opportunityId));
        }
    }, []);


    if (isAdmin && isIdNdaSigned) {
        return (
            <div className="seller-profile-tab">
                <SellerMyProfileForm
                    ref={formRef}
                    setIsSaving={setIsSaving}
                    isEditable={true}
                    isAdmin={true}
                    timelineId={opportunity.opportunityId}
                    onSaveSuccess={() =>
                        createNotification('Profile saved successfully.', 'success')
                    }
                />
                <div className="mt-3">
                    <ButtonLoader
                        className="btn btn-primary"
                        isLoading={isSaving}
                        loaderButtonText=""
                        disabled={isSaving || !sellerProfile?.id}
                        buttonText="Save Profile"
                        onClick={() =>
                            formRef.current?.handleSubmit()
                        }
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="seller-profile-tab">
            <SellerProfileWrapper
                isDisclosed={isIdNdaSigned}
                profileData={sellerProfile}
                timelineId={opportunity.opportunityId}
            />
        </div>
    );
};

export default SellerProfileTab;
